import script from "./site-config-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./site-config-dialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__